<template>
  <div ref="container" class="menu-each-container mt-2">
    <v-btn
      :ref="'button-' + uid"
      tile
      fab
      height="50"
      width="50"
      :color="isBtnActive ? 'primary' : 'white'"
      ripple
      @click="buttonClicked"
      elevation="3"
      class="btn-radius"
    >
      <v-icon v-if="icon !== ''" :color="isBtnActive ? 'white' : 'primary'">{{ icon }}</v-icon>
      <img
        v-if="svg !== ''"
        :src="
          isBtnActive
            ? require('@/assets/icons/ic_' + svg + '_wh.svg')
            : require('@/assets/icons/ic_' + svg + '.svg')
        "
        class="my-auto ml-auto mr-2 mx-sm-auto"
      />
    </v-btn>
    <v-slide-x-transition>
      <v-card
        v-show="isBtnActive"
        :width="width"
        class="menu-form"
        :class="{
          'menu-form-xs': $vuetify.breakpoint.xsOnly,
          'menu-form-above': $vuetify.breakpoint.smAndUp
        }"
        :style="$vuetify.breakpoint.smAndUp ? 'z-index:2' : ''"
        v-click-outside="'click-outside'"
      >
        <v-layout>
          <v-flex xs10>
            <v-card-text class="subtitle-1 black--text">
              <slot name="title"></slot>
            </v-card-text>
          </v-flex>
          <v-flex xs2 class="d-flex justify-end">
            <v-btn icon color="primary" class="ma-2" @click="closeClicked">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <slot name="body"></slot>
      </v-card>
    </v-slide-x-transition>
  </div>
</template>

<script>
export default {
  name: 'BaseFormCard',
  created() {
    this.$on('click-outside', this.clickOutside);
  },
  data: () => ({ isBtnActive: false, clickItself: false }),
  props: {
    width: {
      type: String,
      default() {
        return '0';
      }
    },
    icon: {
      type: String,
      default() {
        return '';
      }
    },
    svg: {
      type: String,
      default: ''
    },
    setActive: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  mounted() {
    if (this.setActive) {
      this.isBtnActive = true;
    }
  },
  methods: {
    clickOutside(event) {
      const { target } = event;
      const parent = document.getElementsByClassName('v-overlay')[0];
      const clickOverlay = parent !== undefined && parent.contains(target);
      const vApp = target.classList.contains('v-application');
      if (!this.clickItself && !clickOverlay && !vApp) {
        this.isBtnActive = false;
      }

      this.clickItself = false;
    },
    buttonClicked() {
      const refName = `button-${this.uid}`;
      const refBtn = this.$refs[refName];
      if (this.$refs.container.contains(refBtn.$el)) {
        this.clickItself = true;
        this.isBtnActive = !this.isBtnActive;
      }
    },
    closeClicked() {
      this.isBtnActive = false;
    }
  },
  computed: {
    uid() {
      /* eslint no-underscore-dangle: 0 */
      return this._uid;
    }
  }
};
</script>
<style lang="scss" scoped>
.menu-form {
  overflow: auto;
  position: fixed;
}
.menu-form-above {
  max-height: calc(100vh - 168px);
  top: 88px;
  left: 80px;
}
.menu-form-xs {
  width: 100vw !important;
  height: 100vh;
  z-index: 5;
  top: 0;
  left: 0px;
}
.menu-each-container {
  * {
    pointer-events: auto;
  }
}
</style>
